module.exports = __webpack_public_path__ + "img/catering.21bd401f.svg";